export type DetailToolbarButtonColorKey =
	| 'actions'
	| 'attach'
	| 'back'
	| 'copy'
	| 'delete'
	| 'edit'
	| 'favorite'
	| 'fullscreen'
	| 'plan'
	| 'publish'
	| 'save'
	| 'send'
	| 'share'
	| 'spam'
	| 'unpublish';

export type DetailToolbarButtonColors = Record<DetailToolbarButtonColorKey, string>;

export const DETAIL_TOOLBAR_BUTTON_COLOR_KEYS: DetailToolbarButtonColorKey[] = [
	'back',
	'fullscreen',
	'edit',
	'save',
	'send',
	'attach',
	'actions',
	'copy',
	'favorite',
	'delete',
	'spam',
	'plan',
	'share',
	'publish',
	'unpublish',
];

export const DEFAULT_DETAIL_TOOLBAR_BUTTON_COLORS: DetailToolbarButtonColors = {
	actions: '#607d8b',
	attach: '#eab308',
	back: '#b5b5b5',
	copy: '#283593',
	delete: '#b87076',
	edit: '#0277bd',
	favorite: '#0277bd',
	fullscreen: '#94a3b8',
	plan: '#00897b',
	publish: '#2563eb',
	save: '#69a675',
	send: '#10b981',
	share: '#0d47a1',
	spam: '#78909c',
	unpublish: '#a6b8e3',
};

const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;

export function isValidHexColor(value: unknown): value is string {
	return typeof value === 'string' && HEX_COLOR_PATTERN.test(value);
}

export function resolveStoredDetailToolbarButtonColors(raw: null | string): DetailToolbarButtonColors {
	if (raw === null) {
		return { ...DEFAULT_DETAIL_TOOLBAR_BUTTON_COLORS };
	}

	try {
		const parsed = JSON.parse(raw) as unknown;

		if (parsed === null || typeof parsed !== 'object') {
			return { ...DEFAULT_DETAIL_TOOLBAR_BUTTON_COLORS };
		}

		const source = parsed as Record<string, unknown>;
		const result: DetailToolbarButtonColors = { ...DEFAULT_DETAIL_TOOLBAR_BUTTON_COLORS };

		for (const key of DETAIL_TOOLBAR_BUTTON_COLOR_KEYS) {
			const value = source[key];

			if (isValidHexColor(value)) {
				result[key] = value;
			}
		}

		return result;
	} catch {
		return { ...DEFAULT_DETAIL_TOOLBAR_BUTTON_COLORS };
	}
}
